import { render, staticRenderFns } from "./Dispatched.vue?vue&type=template&id=76830925&scoped=true&"
import script from "./Dispatched.vue?vue&type=script&lang=js&"
export * from "./Dispatched.vue?vue&type=script&lang=js&"
import style0 from "./Dispatched.vue?vue&type=style&index=0&id=76830925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76830925",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Lang\\pCloudSync\\mats\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76830925')) {
      api.createRecord('76830925', component.options)
    } else {
      api.reload('76830925', component.options)
    }
    module.hot.accept("./Dispatched.vue?vue&type=template&id=76830925&scoped=true&", function () {
      api.rerender('76830925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/tasks/Dispatched.vue"
export default component.exports